import SearchButton from 'components/atoms/SearchButton';
import './styles.scss';
import useSearchBar from './hooks/useSearchBar';

const SearchBar = ({ redirect = false }) => {
  const { onSubmit, searchInputValue, handleOnChange } = useSearchBar(redirect);

  return (
    <form className="searchBar" onSubmit={onSubmit}>
      <input required type="text" className="searchBar__input" name="search" value={searchInputValue} onChange={handleOnChange} />
      <label className="searchBar__label" htmlFor="search">
        Busque por número, título ou palavra-chave
      </label>
      <span className="searchBar__button">
        <SearchButton />
      </span>
    </form>
  );
};

export default SearchBar;
